import { render } from "./Years.vue?vue&type=template&id=66f0f614"
import script from "./Years.vue?vue&type=script&lang=js"
export * from "./Years.vue?vue&type=script&lang=js"

import "./Years.vue?vue&type=style&index=0&id=66f0f614&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__